// extracted by mini-css-extract-plugin
module.exports = {"container":"payment-info-page_container__T4RL4","content":"payment-info-page_content__s9lMM"};